import React from 'react';

const LogoutIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M7.5 5.99984V13.9915C7.5 16.6665 9.16667 18.3332 11.8333 18.3332H13.9917C16.6583 18.3332 18.325 16.6665 18.325 13.9998V5.99984C18.3333 3.33317 16.6667 1.6665 14 1.6665H11.8333C9.16667 1.6665 7.5 3.33317 7.5 5.99984Z"
      fill="#F05252"
    />
    <path
      d="M4.64089 6.7666L1.84922 9.55827C1.60755 9.79994 1.60755 10.1999 1.84922 10.4416L4.64089 13.2333C4.88255 13.4749 5.28255 13.4749 5.52422 13.2333C5.76589 12.9916 5.76589 12.5916 5.52422 12.3499L3.79922 10.6249H12.7076C13.0492 10.6249 13.3326 10.3416 13.3326 9.99993C13.3326 9.65827 13.0492 9.37493 12.7076 9.37493H3.79922L5.52422 7.64994C5.64922 7.52494 5.70755 7.3666 5.70755 7.20827C5.70755 7.04993 5.64922 6.88327 5.52422 6.7666C5.28255 6.5166 4.89089 6.5166 4.64089 6.7666Z"
      fill="#F05252"
    />
  </svg>
);

export default LogoutIcon;
